import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import UploadTable from "../FormProcess/ProcessContents/SectionContent/UploadDocument/UploadTable";

function ScholarshipForm() {
  const [open, setOpen] = React.useState(false);

  const Navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
    Navigate("/admin-page/student");
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [formData, setFormData] = useState({
    scholarshipType: "",
    graduationType: "",
    scholarshipStatus: "",
    dateApplied: "",
  });

  const handleInputChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check for empty fields
    const isEmptyField = Object.values(formData).some((value) => value === "");

    if (isEmptyField) {
      alert("Please fill out all fields");
    } else {
      // Submit the form (you can implement your submission logic here)

      console.log("data");

      //  console.log("Form submitted:", );
      setFormData({
        scholarshipType: "",
        graduationType: "",
        scholarshipStatus: "",
        dateApplied: "",
      });
    }
  };
  return (
    <div className="w-full con-main-table-inner">
      <UploadTable />
    </div>
  );
}

export default ScholarshipForm;
